var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lib-button click",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v("按钮")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }